/**
 * File lazy-video.js.
 * Handles logic for the lazy loaded videos.
 */

let currentVideoItem = null;
let videoHtml = null;

function stripScriptTags(videoHtml) {
  // if videoHtml does not contain any script tag, return it
  if (!videoHtml.includes('<script')) {
    return videoHtml.trim();
  }

  // foreach script in videoHtml, save the src to scriptArray and remove it
  let scriptArray = [];
  const scripts = videoHtml.match(/<script.*?>.*?<\/script>/gs);
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    const scriptSrc = script.match(/<script.*?src="(.*?)"/)[1];
    scriptArray[i] = scriptSrc;
    videoHtml = videoHtml.replace(script, '');
  }

  // foreach script in scriptArray, create a script and append it to the body
  for (let i = 0; i < scriptArray.length; i++) {
    const script = scriptArray[i];
    const scriptEl = document.createElement('script');
    scriptEl.src = script;
    scriptEl.async = true;
    scriptEl.classList.add('video-list-script');
    document.body.appendChild(scriptEl);
  }

  return videoHtml.trim();
}

function toggleOverlay(videoItem, change) {
  switch (change) {
    case 'loading':
      videoItem.classList.remove('playing');
      videoItem.classList.add('loading');
      break;
    case 'show':
      videoItem.classList.remove('loading');
      videoItem.classList.add('playing');
      break;
    case 'hide':
      videoItem.classList.remove('playing', 'loading');
      break;
  }
}

function loadIframe(videoItem) {
  const slideIframe = videoItem.querySelector('iframe');

  // if iframe exists, wait for it to load, then hide overlay
  if (slideIframe) {
    slideIframe.addEventListener('load', function () {
      toggleOverlay(videoItem, 'show');
    });
  }
  
  // if iframe does not exist, just hide overlay
  else {
    toggleOverlay(videoItem, 'show');
  }
}

function removeIframe(videoItem) {
  if (!videoItem) videoItem = currentVideoItem;
  if (!videoItem) return;
  
  // check if there is a video to remove
  if (videoItem.querySelector('iframe')) {
    videoItem.removeChild(videoItem.lastChild);
  }

  toggleOverlay(videoItem, 'hide');

  // clear currentVideoItem - needed if called from another script
  if (videoItem == currentVideoItem) {
    currentVideoItem = null;
  }
}

function prepIframe(videoItem) {
  if (currentVideoItem) {
    removeIframe(currentVideoItem);
  }
  currentVideoItem = videoItem;

  videoHtml = stripScriptTags(videoItem.getAttribute('data-video'));
  videoItem.insertAdjacentHTML('beforeend', videoHtml);

  // prepare video for lazy loading
  const lazyNoscript = videoItem.querySelector('noscript.loading-lazy')
  if (typeof loadingAttributePolyfill !== 'undefined' && lazyNoscript) loadingAttributePolyfill.prepareElement(lazyNoscript);

  // replace play btn with loading icon
  toggleOverlay(videoItem, 'loading');

  // quick timeout to allow for iframe to be created in modal
  window.setTimeout(function () {
    loadIframe(videoItem);
  }, 300);
}

/**
 * Inits
 */
let lazyLoadedVideos = [];
function initLazyVideos(container = document) {
  if (typeof jQuery == 'undefined') {
    return;
  }

  const lazyVideos = container.querySelectorAll('.lazy-video');

  // if no lazy videos, return
  if (lazyVideos.length === 0) {
    return;
  }

  for (let i = 0; i < lazyVideos.length; i++) {
    // if video is already loaded, skip it
    if (lazyLoadedVideos.includes(lazyVideos[i])) continue;

    // add video to lazyLoadedVideos array
    lazyLoadedVideos.push(lazyVideos[i]);

    // add click event to load video
    lazyVideos[i].addEventListener('click', function (e) {
      e.preventDefault();
      prepIframe(lazyVideos[i]);
    });
  }
}

initLazyVideos();
